import { FC } from 'react';
import _ from 'lodash';
import DefaultLandingPage from './Default';
import { LandingPageProps } from './types.type';
import QubitLandingPage from './TenantPages/Qubit';
import StockwizLandingPage from './TenantPages/Stockwiz';
import { PARTNER_NAME } from 'v2/common/utils/types.type';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import { WithResponsiveProvider } from 'v3/common/provider/WithReponsiveProvider';


const LandingPage: FC<LandingPageProps> = (props) => {
  switch (_.toLower(ApplicationDomainUtility.partnerName)) {
    case PARTNER_NAME.STOCKWIZ:
      return <StockwizLandingPage />;
    case PARTNER_NAME.QUBIT:
      return <QubitLandingPage {...props} />;
    default:
      return <DefaultLandingPage {...props} />;
  }
};

export default WithResponsiveProvider(LandingPage);
